import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { ShieldCheck, ArrowLeft } from 'lucide-react';

export function TwoFactorScreen({ onSubmit, onCancel, pendingEmail, bgImage, logoUrl }) {
  const [totpCode, setTotpCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSubmit(totpCode);
    } catch {
      setTotpCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page-2fa">
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-slate-50">
        <div className="w-full max-w-md">
          <div className="flex justify-center mb-8">
            <img src={logoUrl} alt="Diocèse de Pamiers" className="h-24 w-24 rounded-full shadow-lg bg-white p-2" />
          </div>
          <Card className="border-slate-200 shadow-lg">
            <CardHeader className="text-center pb-4">
              <div className="flex justify-center mb-4">
                <div className="p-3 bg-blue-100 rounded-full"><ShieldCheck className="h-8 w-8 text-blue-600" /></div>
              </div>
              <CardTitle className="text-2xl text-[#1e3a8a]">Vérification en deux étapes</CardTitle>
              <CardDescription className="text-slate-600">Entrez le code à 6 chiffres de votre application d'authentification</CardDescription>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="totp_code" className="text-slate-700">Code de vérification</Label>
                  <Input id="totp_code" type="text" value={totpCode} onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))} placeholder="000000" className="border-slate-200 focus:ring-[#c5a059] text-center text-2xl tracking-widest font-mono" maxLength={6} autoFocus autoComplete="one-time-code" data-testid="2fa-code-input" />
                </div>
                <Button type="submit" disabled={loading || totpCode.length !== 6} className="w-full bg-[#1e3a8a] hover:bg-[#1e40af] text-white btn-animate" data-testid="2fa-submit-button">
                  {loading ? <div className="spinner mr-2" /> : <ShieldCheck className="mr-2 h-4 w-4" />} Vérifier
                </Button>
                <Button type="button" variant="ghost" onClick={() => { onCancel(); setTotpCode(''); }} className="w-full text-slate-600 hover:text-slate-800" data-testid="2fa-cancel-button">
                  <ArrowLeft className="mr-2 h-4 w-4" /> Retour à la connexion
                </Button>
              </form>
              <p className="mt-4 text-xs text-center text-slate-500">Connecté en tant que : {pendingEmail}</p>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className="hidden lg:block lg:w-1/2 bg-cover bg-center" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="h-full w-full bg-[#1e3a8a]/60 flex items-center justify-center p-12">
          <div className="text-center text-white max-w-lg">
            <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Merriweather, serif' }}>Sécurité renforcée</h1>
            <p className="text-lg text-white/90">L'authentification à deux facteurs protège votre compte contre les accès non autorisés.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
